import { ComponentColor } from "@common/types";
import {
    OrderStatusType,
    PaymentMethodType,
    PaymentStatusType,
} from "@models/order";

// Human label + daisyUI badge color for each order status.
export const STATUS_META: Record<
    OrderStatusType,
    { label: string; color: ComponentColor }
> = {
    [OrderStatusType.None]: { label: "—", color: ComponentColor.Ghost },
    [OrderStatusType.Received]: {
        label: "Received",
        color: ComponentColor.Warning,
    },
    [OrderStatusType.Processing]: {
        label: "Processing",
        color: ComponentColor.Info,
    },
    [OrderStatusType.Shipped]: {
        label: "Shipped",
        color: ComponentColor.Accent,
    },
    [OrderStatusType.Delivered]: {
        label: "Delivered",
        color: ComponentColor.Success,
    },
    [OrderStatusType.Cancelled]: {
        label: "Cancelled",
        color: ComponentColor.Error,
    },
};

// URL <-> enum mapping for the `status` query param. "All" is the absence of
// the param, so it has no key here.
export const STATUS_PARAM_TO_ENUM: Partial<Record<string, OrderStatusType>> = {
    received: OrderStatusType.Received,
    processing: OrderStatusType.Processing,
    shipped: OrderStatusType.Shipped,
    delivered: OrderStatusType.Delivered,
    cancelled: OrderStatusType.Cancelled,
};

export const ENUM_TO_STATUS_PARAM: Partial<Record<OrderStatusType, string>> = {
    [OrderStatusType.Received]: "received",
    [OrderStatusType.Processing]: "processing",
    [OrderStatusType.Shipped]: "shipped",
    [OrderStatusType.Delivered]: "delivered",
    [OrderStatusType.Cancelled]: "cancelled",
};

// Human labels for the integer payment enums on the admin order detail (#298).
// Keyed by number because AdminOrderDetailResponse.paymentStatus is
// `number | null`; unknown values fall back to the raw number.
const PAYMENT_STATUS_LABELS: Record<number, string> = {
    [PaymentStatusType.None]: "—",
    [PaymentStatusType.Unpaid]: "Unpaid",
    [PaymentStatusType.AuthOnly]: "Auth only",
    [PaymentStatusType.Captured]: "Captured",
    [PaymentStatusType.Failed]: "Failed",
    [PaymentStatusType.PendingSettlement]: "Pending settlement",
};

export const paymentStatusLabel = (
    status: number | null | undefined,
): string => {
    if (status === null || status === undefined) {
        return "—";
    }
    return PAYMENT_STATUS_LABELS[status] ?? String(status);
};

const PAYMENT_METHOD_LABELS: Record<number, string> = {
    [PaymentMethodType.None]: "—",
    [PaymentMethodType.Card]: "Card",
    [PaymentMethodType.BankAccount]: "Bank (eCheck)",
};

export const paymentMethodLabel = (
    method: number | null | undefined,
): string => {
    if (method === null || method === undefined) {
        return "—";
    }
    return PAYMENT_METHOD_LABELS[method] ?? String(method);
};
